import { FormConfigItem } from "../../../types/form";

/**
 * Per-form "Checklist Options". Absent means enabled: forms built before these options existed
 * carry neither param and must keep showing both controls, and the spec's default for each is On.
 *
 * Read by both the input control (which hands them to react-ui as `showDueDate` / `showAssignee`)
 * and the review page, so a builder who hid due dates on the form does not see them reappear in
 * the submission summary.
 */
export const isChecklistDueDateEnabled = (formItem: FormConfigItem): boolean =>
  formItem.params.due_date_enabled !== false;

export const isChecklistAssigneeEnabled = (formItem: FormConfigItem): boolean =>
  formItem.params.assignee_enabled !== false;
